import { jsx as _jsx } from "react/jsx-runtime";
import { CatTabs } from '@blocks-react/components/Tabs';
export const MyEquipmentTabs = ({ children, activeIndex, onBlTabChange, behavior = 'full-width', }) => {
    return (_jsx(CatTabs, { variant: "contrast", behavior: behavior, activeIndex: activeIndex, onBlTabChange: onBlTabChange, children: children }));
};
